import Router from "./Router";
import Navigation from "./Navigation";
import View from "./View";
import Utils from "./Utils";
import I18n from "./I18n";

class App{
    constructor(){
        this.Router = Router;
        this.Navigation = Navigation;
        this.View = View;
        this.Utils = Utils;
        this.I18n = I18n;

        this.$window = $( window );
        this.$document = $( document );

        this.is_loaded = false;
        this.on_load_callbacks = [];
        this.watchLoad();

        this.breakpoints = {
            sm : 700,
            md : 1000,
        }

        this.$document.ready( _ => {
            this.$body = $( document.body );
            this.$html = $( "html" );
            this.$bodyHtml = this.$body.add( this.$html );
            this.whenReady( _ => this.$body.addClass( '__has-loaded' ) );
        } );
    }

    whenReady( callback ){
        if( this.is_loaded ){
            callback.call(window);
        }else{
            this.on_load_callbacks.push( callback );
        }
    }

    watchLoad(){
        let window_load_def = new $.Deferred();
        let images_load_def = new $.Deferred();
        let video_load_def = new $.Deferred();

        if( document.readyState !== "complete" ){
            this.$window.on( 'load', _ => window_load_def.resolve() );
        }else{
            window_load_def.resolve()
        }

        Utils.imagesLoaded( document.body, { background : '.js-background-image' } ).on( 'always', _ => images_load_def.resolve() );

        let $video = $( 'video' ), num_loaded_vid = 0;
        function checkLoad() {
            if( $video.filter( (i, v) => v.readyState === 4 ).length == $video.length ){
                video_load_def.resolve()
            } else {
                setTimeout(checkLoad, 100);
            }
        }

        $.when( window_load_def, images_load_def ).done( $.proxy( this.appLoaded, this ) );
    }

    appLoaded(){
        this.is_loaded = true;
        $.each( this.on_load_callbacks, function(){
            this.call( window );
        } );
    }
}

window.App = new App;
export default window.App;



// WEBPACK FOOTER //
// ./resources/assets/js/framework/App.js